import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Component } from 'react';
import { AxiosError } from 'axios';
import { connect, Dispatch } from 'react-redux';
import {
    IApplicationState, AppActionCreators, MatchingActionCreators, IMatchRunResultsResponse, IRequestRexmResponse, IMatchRunResponse,
    IRequestRexmBatchResponse,
    IMatchRunScenariosResponse,
    TargetActionCreators,
    IDonorsPerMonthByAboResponse,
    IDonorProfileAcceptsResponse,
    DonorActionCreators
} from '@nkr/store/index';
import {
    IMatchRunSwap, IMatchRunSettings, IMatchRunResults, IMatchRunChainStarter, IBaseResponse, ISwapFailureAnalysis, IMatchRun,
    IOneWay, IDonor, ICenterBase, ISingleEpletMmRisk, IMatchRunScenario, ISortBy, IMatchRunDiagnostics,
    IDonorsPerMonthByAbo,
} from '@nkr/models/index';
import { MatchRunStatus, MatchRunType, TargetCheckTypeNew } from '@nkr/enums/index';
import { IChainDisplay } from './models';
import { RouteComponentProps } from 'react-router';
import { Alert, Button, Label, OverlayTrigger, Panel, Well } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { ContainerWrapper } from '../styles';
import { DiagnosticsWrapper, TableWrapper } from './styles';
import PopoverTemplate from '@nkr/components/popover-template';
import StringDepth from './string-depth';
import RunStatistics from './run-statistics';
import ChainStarterList from './chain-starter-list';
import Chains from './chains';
import Positions from './positions';
import ChainStarterListLoops from './chain-starter-list-loops';
import RefreshWarning from '@nkr/views/recipient/toolbox/refresh-warning';

interface IProps extends RouteComponentProps<{ matchRunId: string }> { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMatchRun: (id: number) => Promise<IMatchRunResponse>,
    getResults: (id: number) => Promise<IMatchRunResultsResponse>,
    getScenarios: () => Promise<IMatchRunScenariosResponse>,
    requestExm: (matchRunId: number, key: number, donorId: number, recipientId: number) => Promise<IRequestRexmResponse>,
    requestExmBatch: (matchRunId: number, list: { key: number, donorId: number, recipientId: number }[]) => Promise<IRequestRexmBatchResponse>,
    makeMatchOffer: (donorList: { [key: number]: number }, recipientList: { [key: number]: number }, isChain: boolean) => Promise<IBaseResponse>,
    getAcceptsData: (id: number, centerId: number) => Promise<IDonorProfileAcceptsResponse>,
    getDonorsPerMonthByAbo: () => Promise<IDonorsPerMonthByAboResponse>,
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    matchRun: IMatchRun,
    running: boolean,
    swaps: IMatchRunSwap[],
    results: IMatchRunResults,
    chainDisplay: IChainDisplay[],
    settings: IMatchRunSettings,
    diagnosticsData: IMatchRunDiagnostics,
    swapFailures: ISwapFailureAnalysis[],
    oneWays: IOneWay[],
    epletMmRiskList: ISingleEpletMmRisk[],
    selectedCenters: ICenterBase[],
    donors: IDonor[],
    scenarios: IMatchRunScenario[],
    donorsPerMonthByAbo: IDonorsPerMonthByAbo,
    rexmCount: number,
    expandAll: boolean,
    showWarning: boolean,
    sortBy: ISortBy[],
    showSwapFailureColorCoding: number,
    selectedChainStarters: number[],
    scenario: IMatchRunScenario,
    suppressPeds: boolean,
    suppressEpletMM: boolean,
    suppressAge: boolean,
    suppressBloodType: boolean,
    hideSuppressButtons: boolean
}

class Results extends Component<TProps, IState> {
    readonly state: IState = {
        matchRun: null,
        running: true,
        swaps: [],
        results: null,
        chainDisplay: [],
        settings: null,
        diagnosticsData: null,
        swapFailures: [],
        oneWays: [],
        epletMmRiskList: [],
        selectedCenters: [],
        donors: [],
        scenarios: [],
        donorsPerMonthByAbo: null,
        rexmCount: 0,
        expandAll: false,
        showWarning: false,
        sortBy: [
            {
                property: 'depth',
                direction: 'desc'
            }
        ],
        showSwapFailureColorCoding: 0,
        selectedChainStarters: [],
        scenario: null,
        suppressPeds: false,
        suppressEpletMM: true,
        suppressAge: true,
        suppressBloodType: true,
        hideSuppressButtons: false
    }

    interval: any;

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let matchRunId = parseInt(this.props.match.params.matchRunId);
        let parsed = qs.parse(this.props.location.search);
        let scenarioId = parsed.scenario != null ? parseInt(parsed.scenario) : 0;

        this.props.showLoading('Loading match run results, one moment please...').then(async () => {
            let scenariosResponse = await this.props.getScenarios();
            let donorsPerMonthByAboResponse = await this.props.getDonorsPerMonthByAbo();
            let donorsPerMonthByAbo = donorsPerMonthByAboResponse.data.results;

            let { scenarios } = scenariosResponse.data.results;

            let scenario = scenarios.find(x => x.id == scenarioId);

            let sortBy = [...this.state.sortBy];

            if (scenario != null && scenario.group.specialSort) {
                sortBy = [
                    {
                        property: 'voucherHolderAbo',
                        direction: 'desc'
                    },
                    {
                        property: 'depth',
                        direction: 'desc'
                    },
                    {
                        property: 'numberOfLowRiskEpletMM',
                        direction: 'desc'
                    }
                ];
            }

            document.title = scenario ? 'BM3: ' + scenario.group.name + ' ' + scenario.title : 'BM3: Results';

            let matchRunResponse = await this.props.getMatchRun(matchRunId);

            let { success, results: matchRun } = matchRunResponse.data;

            if (success && matchRun.status == MatchRunStatus.Completed) {
                this.setState({
                    scenarios,
                    scenario,
                    sortBy,
                    donorsPerMonthByAbo
                }, () => {
                    this.getResults(matchRun, true);
                    // this.getMockResults(matchRun, true);
                });
            } else {
                this.setState({
                    scenarios,
                    matchRun,
                    scenario,
                    donorsPerMonthByAbo
                }, () => {
                    this.interval = setInterval(() => this.refresh(), 3000);
                });

                this.props.hideLoading();
            }
        });
    }

    getResults = async (matchRun: IMatchRun, clearTimer: boolean) => {
        let resultsResponse = await this.props.getResults(matchRun.id);

        // let { swaps, results, chains, settings, swapFailures, oneWays, epletMmRiskList, zeroDepthChainStartDonors, selectedCenters, diagnosticsData, chainsToDisplay, rexmCount, donorList } = resultsResponse.data.results;

        // //let donors = _.uniqBy(oneWays.map(x => x.donor), x => x.id);
        // let donors = donorList;
        // donors.push(...zeroDepthChainStartDonors);

        let { swaps, results, chains, settings, swapFailures, oneWays, epletMmRiskList, zeroDepthChainStartDonors, selectedCenters, diagnosticsData, chainsToDisplay, rexmCount } = resultsResponse.data.results;

        let donors = _.uniqBy(oneWays.map(x => x.donor), x => x.id);
        donors.push(...zeroDepthChainStartDonors);

        let chainDisplay = chainsToDisplay.map(chain => {
            return { ...chain, isExpanded: false, isSelected: false, isDeleted: false, rank: 0 };
        });

        let selectedChainStarters = _.uniq(swaps.map(swap => swap.chainStart));

        let scenario = this.state.scenario;
        let sortBy = [...this.state.sortBy];

        if (settings.scenario > 0) {
            scenario = this.state.scenarios.find(x => x.id == settings.scenario);

            if (scenario != null && scenario.group.specialSort) {
                sortBy = [
                    {
                        property: 'voucherHolderAbo',
                        direction: 'desc'
                    },
                    {
                        property: 'depth',
                        direction: 'desc'
                    },
                    {
                        property: 'numberOfLowRiskEpletMM',
                        direction: 'desc'
                    }
                ];
            }
        }

        if (scenario != null) {
            const suppressedTypes = [TargetCheckTypeNew.Regular];

            if (suppressedTypes.includes(scenario.group.checkType) && scenario.group.stalled == false) {
                this.setState({
                    suppressAge: true,
                    suppressEpletMM: true,
                    suppressBloodType: true
                })
            }
        }

        if (scenario != null) {
            const suppressedTypes = [TargetCheckTypeNew.HardToMatch];

            if (suppressedTypes.includes(scenario.group.checkType as number)) {
                this.setState({
                    suppressAge: false,
                    suppressEpletMM: false,
                    suppressBloodType: false
                })
            }
        }


        if (scenario != null) {
            const suppressedTypes = [TargetCheckTypeNew.Future, TargetCheckTypeNew.Regular, TargetCheckTypeNew.Open];

            if (suppressedTypes.includes(scenario.group.checkType as number) && scenario.group.stalled) {
                this.setState({
                    suppressAge: false,
                    suppressEpletMM: true,
                    suppressBloodType: false
                })
            }
        }

        this.setState({
            matchRun,
            swaps,
            results,
            chainDisplay,
            settings,
            diagnosticsData,
            swapFailures,
            oneWays,
            epletMmRiskList,
            selectedCenters,
            donors,
            selectedChainStarters,
            running: false,
            scenario,
            rexmCount,
            sortBy
        }, () => {
            if (clearTimer) {
                clearInterval(this.interval);
            }

            this.props.hideLoading();

            document.title = scenario ? 'BM3: ' + scenario.group.name + ' ' + scenario.title : 'BM3: Results';
        });
    }

    // getMockResults = async (matchRun: IMatchRun, clearTimer: boolean) => {
    //     let mockResults: { success: boolean, results: IMatchRunFullResults } = require('./results.json');

    //     let resultsResponse: IMatchRunResultsResponse = {
    //         data: mockResults
    //     };

    //     let { swaps, results, chains, settings, swapFailures, oneWays, epletMmRiskList, zeroDepthChainStartDonors, selectedCenters, diagnosticsData, chainsToDisplay, rexmCount } = resultsResponse.data.results;

    //     let donors = _.uniqBy(oneWays.map(x => x.donor), x => x.id);
    //     donors.push(...zeroDepthChainStartDonors);

    //     let chainDisplay = chainsToDisplay.map(chain => {
    //         return { ...chain, isExpanded: false, isSelected: false, isDeleted: false, rank: 0 };
    //     });

    //     let selectedChainStarters = _.uniq(swaps.map(swap => swap.chainStart));

    //     let scenario = this.state.scenario;
    //     let sortBy = [...this.state.sortBy];

    //     if (settings.scenario > 0) {
    //         scenario = this.state.scenarios.find(x => x.id == settings.scenario);

    //         if (scenario != null && scenario.group.specialSort) {
    //             sortBy = [
    //                 {
    //                     property: 'voucherHolderAbo',
    //                     direction: 'desc'
    //                 },
    //                 {
    //                     property: 'depth',
    //                     direction: 'desc'
    //                 },
    //                 {
    //                     property: 'numberOfLowRiskEpletMM',
    //                     direction: 'desc'
    //                 }
    //             ];
    //         }
    //     }

    //     if (scenario != null) {
    //         const suppressedTypes = [TargetCheckTypeNew.Regular];

    //         if (suppressedTypes.includes(scenario.group.checkType as number) && scenario.group.stalled == false) {
    //             this.setState({
    //                 suppressAge: true,
    //                 suppressEpletMM: true,
    //                 suppressBloodType: true
    //             })
    //         }
    //     }

    //     this.setState({
    //         matchRun,
    //         swaps,
    //         results,
    //         chainDisplay,
    //         settings,
    //         diagnosticsData,
    //         swapFailures,
    //         oneWays,
    //         epletMmRiskList,
    //         selectedCenters,
    //         donors,
    //         selectedChainStarters,
    //         running: false,
    //         scenario,
    //         rexmCount,
    //         sortBy
    //     }, () => {
    //         if (clearTimer) {
    //             clearInterval(this.interval);
    //         }

    //         this.props.hideLoading();

    //         document.title = scenario ? 'BM3: ' + scenario.group.name + ' ' + scenario.title : 'BM3: Results';
    //     });
    // }

    refresh = () => {
        this.props.getMatchRun(this.state.matchRun.id).then(async matchRunResponse => {
            let { success, results: matchRun } = matchRunResponse.data;

            if (success && matchRun.status == MatchRunStatus.Completed) {
                clearInterval(this.interval);

                this.getResults(matchRun, false);
            } else {
                this.setState({
                    matchRun
                })
            }

            this.props.hideLoading();
        });
    }

    setupChainDisplay = (swaps: IMatchRunSwap[], chains: IMatchRunChainStarter[], epletMmRiskList: ISingleEpletMmRisk[], loops: boolean) => {
        let chainList: IChainDisplay[] = [];

        if (!loops) {
            swaps.forEach((swap, swapIndex) => {
                let chainStarter = chains.find(x => x.chainStarterId == swap.chainStart);

                chainStarter.chains.forEach((chain, chainIndex) => {
                    let epletList: ISingleEpletMmRisk[] = [];

                    chain.path.forEach(p => {
                        let epletMm = epletMmRiskList.find(x => x.donorId == p.donorId && x.recipientId == p.recipientId);

                        if (epletMm != null) {
                            epletList.push(epletMm);
                        }
                    });

                    chain.numberOfLowRiskEpletMM = epletList.filter(x => x.singleEpletRisk == 0 || x.singleEpletRisk == 10).length;

                    chainList.push({ swapIndex, chainIndex, chainStart: swap.chainStart, chain, isExpanded: false, isSelected: false, isDeleted: false, rank: 0 });
                });
            });
        } else {
            let chainStarters = _.uniq(swaps.map(x => x.chainStart));

            chainStarters.forEach((chainStart, swapIndex) => {
                let chainStarter = chains.find(x => x.chainStarterId == chainStart);

                chainStarter.chains.forEach((chain, chainIndex) => {
                    chainList.push({ swapIndex, chainIndex, chainStart: chainStart, chain, isExpanded: false, isSelected: false, isDeleted: false, rank: 0 });
                });
            });
        }

        return chainList;
    }

    getSortedChains = (): IChainDisplay[] => {
        let m = { 'O': 5, 'A': 4, 'B': 3, 'AB': 2, '': 1 };

        let chainDisplay = _.cloneDeep(this.state.chainDisplay);

        let sortedChains = _.orderBy(chainDisplay, this.state.sortBy.map(sortBy => item => {
            let chainId = parseInt(item.swapIndex + (item.chainIndex.toString().length == 1 ? '0' : '') + item.chainIndex);

            switch (sortBy.property) {
                case 'chainId': return chainId;
                case 'depth': return item.chain.depth;
                case 'otoORatio': return item.chain.otoORatio;
                case 'ageDelta': return item.chain.ageDelta;
                case 'donationType': return item.chain.donationTypeAbbreviation;
                case 'patientType': return item.chain.patientTypeAbbreviation;
                case 'maxCpra': return item.chain.maxCpra == null ? -1 : item.chain.maxCpra;
                case 'cpr': return item.chain.cpr;
                case 'highestDeclineRatio': return item.chain.highestDeclineRatio == null ? -1 : item.chain.highestDeclineRatio * 100.0;
                case 'numberOfLowRiskEpletMM': return item.chain.numberOfLowRiskEpletMM;
                case 'averageHla': return item.chain.averageHla;
                case 'sumOfClcScoreEffective': return item.chain.sumOfClcScoreEffective;
                case 'longestWaitTime': return item.chain.longestWaitTime;
                case 'acceptedPreselectStatusPercentage': return item.chain.acceptedPreselectStatusPercentage;
                case 'voucherHolderAbo': return item.chain.voucherHolderAbo ?? '';
            }

            return '';
        }), this.state.sortBy.map(sortBy => sortBy.direction));

        if (this.state.matchRun.matchRunType == MatchRunType.Loops) {
            sortedChains = sortedChains.filter(x => {
                return this.state.selectedChainStarters.indexOf(x.chainStart) >= 0;
            });
        }

        return sortedChains.map((x, index) => ({ ...x, rank: index }));
    }

    getConfigOverlay = () => {
        let settings = {
            maxChainDepth: 0,
            maxLoopDepth: 0,
            isolateDeepestNVal: 0,
            onlyPreAcceptedOneWaysVal: false,
            chipsIfFncs3IsLessThan1Val: false,
            onlyOtoOVal: false,
            onlyOBds: false,
            ignoreBlockAllDonorsVal: false,
            endOfAboO: false
        };

        if (this.state.settings != null) {
            settings.maxChainDepth = this.state.settings.maxChainDepthVal;
            settings.maxLoopDepth = this.state.settings.maxLoopDepthVal;
            settings.isolateDeepestNVal = this.state.settings.isolateDeepestNVal;
            settings.onlyPreAcceptedOneWaysVal = this.state.settings.onlyPreAcceptedOneWaysVal;
            settings.chipsIfFncs3IsLessThan1Val = this.state.settings.chipsIfFncs3IsLessThan1Val;
            settings.onlyOtoOVal = this.state.settings.onlyOtoOVal;
            settings.onlyOBds = this.state.settings.onlyOBds;
            settings.ignoreBlockAllDonorsVal = this.state.settings.ignoreBlockAllDonorsVal;
            settings.endOfAboO = this.state.settings.endOnAboO;
        }

        let showDiagnostics =
            this.state.diagnosticsData != null

            && this.state.diagnosticsData.targetsPageMiracleMatches != null
            && this.state.diagnosticsData.matchRunMiracleMatches != null

            && this.state.diagnosticsData.targetsPagePriority12 != null
            && this.state.diagnosticsData.matchRunPriority12 != null

            && this.state.diagnosticsData.targetsPagePriority14 != null
            && this.state.diagnosticsData.matchRunPriority14 != null

            && this.state.diagnosticsData.targetsPagePriority15 != null
            && this.state.diagnosticsData.matchRunPriority15 != null;

        return (
            <PopoverTemplate bsSize='lg' id='match-run-settings' title='Match Run Configuration'>
                <TableWrapper striped condensed bordered>
                    <tbody>
                        <tr>
                            <th>Run Type:</th>
                            <td style={{ textAlign: 'center' }}>{this.state.matchRun.matchRunTypeDescription}</td>
                        </tr>

                        <tr>
                            <th>{this.state.matchRun.matchRunType == MatchRunType.Chains ? 'Max Chain Depth' : 'Max Loop Depth'}:</th>
                            <td style={{ textAlign: 'center' }}>{this.state.matchRun.matchRunType == MatchRunType.Chains ? settings.maxChainDepth : settings.maxLoopDepth}</td>
                        </tr>

                        <tr>
                            <th>Use Only Pre-Accepted Donors:</th>
                            <td style={{ textAlign: 'center' }}>{settings.onlyPreAcceptedOneWaysVal ? 'Yes' : 'No'}</td>
                        </tr>

                        <tr>
                            <th>Only 'O' to 'O':</th>
                            <td style={{ textAlign: 'center' }}>{settings.onlyOtoOVal ? 'Yes' : 'No'}</td>
                        </tr>

                        <tr>
                            <th>Return Only 'O' Paired Donors:</th>
                            <td style={{ textAlign: 'center' }}>{settings.onlyOBds ? 'Yes' : 'No'}</td>
                        </tr>
                    </tbody>
                </TableWrapper>

                <Panel style={{ marginBottom: 10 }}>
                    <Panel.Heading>Selected Centers</Panel.Heading>
                    <Panel.Body style={{ padding: 0 }}>
                        <div style={{ height: 200, overflowY: 'scroll', padding: 4 }}>
                            {this.state.selectedCenters.map((center, index) =>
                                <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{center.alias}</span>
                            )}
                        </div>
                    </Panel.Body>
                </Panel>

                {showDiagnostics && (
                    <Panel>
                        <Panel.Heading>Diagnostics Data</Panel.Heading>
                        <Panel.Body style={{ padding: 0 }}>
                            <DiagnosticsWrapper>
                                <div className='diag-title'>Targets Page Load Date/Time</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.targetsPageLoadDateTime != '' ?
                                        moment(this.state.diagnosticsData.targetsPageLoadDateTime).format('MM/DD/YYYY HH:mm')
                                        :
                                        <Label>No targets page load date/time...</Label>
                                    }
                                </div>

                                <div className='diag-title'>Targets Page Miracle Matches</div>
                                <div className='diag-section'>
                                    {_.uniq(this.state.diagnosticsData.targetsPageMiracleMatches).map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}

                                    {this.state.diagnosticsData.targetsPageMiracleMatches.length == 0 && (
                                        <Label>No targets page miracle match recipients...</Label>
                                    )}
                                </div>

                                <div className='diag-title'>Match Run Miracle Matches</div>
                                <div className='diag-section'>
                                    {_.uniq(this.state.diagnosticsData.matchRunMiracleMatches).map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}
                                </div>

                                <div className='diag-title'>Targets Page Priority 1-2</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.targetsPagePriority12.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}

                                    {this.state.diagnosticsData.targetsPagePriority12.length == 0 && (
                                        <Label>No targets page priority 1-2 recipients...</Label>
                                    )}
                                </div>

                                <div className='diag-title'>Match Run Priority 1-2</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.matchRunPriority12.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}
                                </div>

                                <div className='diag-title'>Targets Page Priority 1-4</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.targetsPagePriority14.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}

                                    {this.state.diagnosticsData.targetsPagePriority14.length == 0 && (
                                        <Label>No targets page priority 1-4 recipients...</Label>
                                    )}
                                </div>

                                <div className='diag-title'>Match Run Priority 1-4</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.matchRunPriority14.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}
                                </div>

                                <div className='diag-title'>Targets Page Priority 1-5</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.targetsPagePriority15.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}

                                    {this.state.diagnosticsData.targetsPagePriority15.length == 0 && (
                                        <Label>No targets page priority 1-5 recipients...</Label>
                                    )}
                                </div>

                                <div className='diag-title'>Match Run Priority 1-5</div>
                                <div className='diag-section'>
                                    {this.state.diagnosticsData.matchRunPriority15.map((item, index) =>
                                        <span key={'sel-center-' + index}>{index > 0 ? ', ' : ''}{item}</span>
                                    )}
                                </div>

                                <div className='diag-title'>REXM's Requested</div>
                                <div>
                                    {this.state.rexmCount}
                                </div>
                            </DiagnosticsWrapper>
                        </Panel.Body>
                    </Panel>
                )}
            </PopoverTemplate >
        );
    }

    handleChainSortChanged = (sortBy: ISortBy[]) => {
        if (this.state.scenario && this.state.scenario.group.specialSort && sortBy.length == 0) {
            sortBy = [
                {
                    property: 'voucherHolderAbo',
                    direction: 'desc'
                },
                {
                    property: 'numberOfLowRiskEpletMM',
                    direction: 'asc'
                },
                {
                    property: 'longestWaitTime',
                    direction: 'desc'
                }
            ];
        }

        this.setState({
            sortBy
        });
    }

    handleExpandChange = (swapIndex: number, chainIndex: number) => {
        let chainDisplay = _.cloneDeep(this.state.chainDisplay).map(chainItem => {
            if (chainItem.swapIndex == swapIndex && chainItem.chainIndex == chainIndex) {
                chainItem.isExpanded = !chainItem.isExpanded;
            }

            return chainItem;
        });

        this.setState({
            chainDisplay
        });
    }

    handleExpandAll = () => {
        let expandAll = !this.state.expandAll;

        let chainDisplay = _.cloneDeep(this.state.chainDisplay).map(chainItem => {
            chainItem.isExpanded = expandAll;
            return chainItem;
        });

        this.setState({
            chainDisplay,
            expandAll
        });
    }

    handleSelectChange = (swapIndex: number, chainIndex: number, rank: number) => {
        let startingIndex = this.getSortedChains().findIndex(x => x.swapIndex == swapIndex && x.chainIndex == chainIndex);

        let chainDisplay = this.getSortedChains().map((chain, index) => {
            if (index >= startingIndex) {
                chain.isSelected = !chain.isSelected;
            }

            return chain;
        });

        this.setState({
            chainDisplay
        });
    }

    handleDeleteSelected = () => {
        let chainDisplay = this.getSortedChains().map(chain => {
            if (chain.isSelected) {
                chain.isDeleted = true;
            }

            return chain;
        });

        this.setState({
            chainDisplay
        });
    }

    handleRestoreDeleted = () => {
        let chainDisplay = this.getSortedChains().map(chain => {
            chain.isDeleted = false;
            return chain;
        });

        this.setState({
            chainDisplay
        });
    }

    handleRequestExm = (oneWayId: number) => {
        let oneWay = this.state.oneWays.find(x => x.id == oneWayId);

        this.props.showLoading('Sending RFP, one moment please...').then(() => {
            this.props.requestExm(this.state.matchRun.id, oneWayId, oneWay.donor.id, oneWay.recipient.id)
                .then(response => {
                    if (response.data.success) {
                        toast.success('RFP sent successfully');

                        let oneWays = _.cloneDeep(this.state.oneWays).map(oneWay => {
                            if (oneWay.id == oneWayId) {
                                oneWay.exmDisplayString = response.data.results;
                            }

                            return oneWay;
                        });

                        this.setState({
                            oneWays
                        }, () => {
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                    toast.error('Unable to send RDFR: ' + error.message);
                });
        });
    }

    handleRequestExmBatch = (oneWayList: number[]) => {
        let list = this.state.oneWays.filter(x => oneWayList.indexOf(x.id) >= 0).map(x => {
            return {
                key: x.id,
                donorId: x.donor.id,
                recipientId: x.recipient.id
            };
        });

        this.props.requestExmBatch(this.state.matchRun.id, list)
            .then(response => {
                let oneWays = _.cloneDeep(this.state.oneWays).map(oneWay => {
                    let resultsString = response.data.results[oneWay.id];

                    if (resultsString != undefined) {
                        oneWay.exmDisplayString = resultsString;
                    }

                    return oneWay;
                });

                this.setState({
                    oneWays
                });
            })
            .catch((error: AxiosError) => {
                toast.error('Unable to send RDFR batch: ' + error.message);
            });
    }

    handleMakeMatchOffer = (donorList: { [key: number]: number }, recipientList: { [key: number]: number }) => {
        let isChain = this.state.matchRun.matchRunType == MatchRunType.Chains;

        this.props.showLoading('Creating match offers, one moment please...').then(() => {
            this.props.makeMatchOffer(donorList, recipientList, isChain)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Match offer made successfully');
                    } else {
                        toast.error('Chain starting donor is already in a swap...', {
                            className: 'offer-warning',
                            bodyClassName: 'offer-warning-large-font',
                            autoClose: false,
                            closeOnClick: false,
                            closeButton: ({ closeToast }) => <Button onClick={closeToast}>Dismiss</Button>
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleHide =(swapIndex: number, chainIndex: number) => {
        let chainDisplay = _.cloneDeep(this.state.chainDisplay).map(chain => {
            if (chain.swapIndex == swapIndex && chain.chainIndex == chainIndex) {
                chain.isExpanded = false;
            }

            return chain;
        });

        this.setState({
            chainDisplay
        });
    }

    handleShowSwapFailureColorCoding = (showSwapFailureColorCoding: number) => {
        this.setState({
            showSwapFailureColorCoding
        });
    }

    handleSelectedChainStartersChanged = (selectedChainStarters: number[]) => {
        this.setState({
            selectedChainStarters
        });
    }

    handleSuppressEpletMM = (suppress: boolean) => {
        this.setState({
            suppressEpletMM: suppress,
        });
    }

    handleSuppressPeds = (suppress: boolean) => {
        this.setState({
            suppressPeds: suppress
        });
    }

    handleSuppressAge = (suppress: boolean) => {
        this.setState({
            suppressAge: suppress,
        });
    }

    handleSuppressBloodType = (suppress: boolean) => {
        this.setState({
            suppressBloodType: suppress,
        });
    }

    handleCloseWarning = () => {
        this.setState({
            showWarning: false
        });
    }

    renderProgress = (item: IMatchRun) => {
        let startedDateTime = item != null && item.startedDateTime != '' ? moment(item.startedDateTime).utc() : moment().utc();
        let className = item.currentStage == '' ? 'label label-default' : 'label label-info';

        let elapsedTime = moment().utc().diff(startedDateTime, 'seconds');
        let minutes = elapsedTime / 60 > 1 ? Math.round(elapsedTime / 60) : 0;
        let seconds = elapsedTime % 60;

        return (
            <div className={className} style={{ display: 'block', fontSize: '100%', width: '100%', lineHeight: 3 }}>{item.currentStage != '' ? item.currentStage : 'Pending Execution...'} {minutes < 10 ? '0' + minutes : minutes}:{seconds < 10 ? '0' + seconds : seconds}</div>
        );
    }

    render = () => {
        if (this.state.running && this.state.matchRun == null) {
            return null;
        }

        const { suppressEpletMM, suppressAge, suppressBloodType, suppressPeds, scenario } = this.state;

        let expandedPositions = this.getSortedChains().filter(x => x.isExpanded && x.isDeleted == false);
        let chainList = this.getSortedChains();

        if (scenario != null) {
            const suppressedTypes = [TargetCheckTypeNew.Future, TargetCheckTypeNew.Regular, TargetCheckTypeNew.Open];

            if ((suppressedTypes.includes(scenario.group.checkType) && scenario.group.stalled) || scenario.group.checkType == TargetCheckTypeNew.Open || scenario.group.checkType == TargetCheckTypeNew.Loops) {
                chainList = chainList.filter(x => !x.chain.isKRCExcluded);
                expandedPositions = expandedPositions.filter(x => !x.chain.isKRCExcluded);
            }
        }

        if (suppressEpletMM) {
            expandedPositions = expandedPositions.filter(x => x.chain.isSuppressibleEplet != true)
            chainList = chainList.filter(x => x.chain.isSuppressibleEplet != true);
        }

        if (suppressAge) {
            expandedPositions = expandedPositions.filter(x => x.chain.isSuppressibleAge != true)
            chainList = chainList.filter(x => x.chain.isSuppressibleAge != true);
        }

        if (suppressBloodType) {
            expandedPositions = expandedPositions.filter(x => x.chain.isSuppressibleNonO != true)
            chainList = chainList.filter(x => x.chain.isSuppressibleNonO != true);
        }

        if (suppressPeds) {
            expandedPositions = expandedPositions.filter(x => x.chain.isSuppressiblePeds == true);
            chainList = chainList.filter(x => x.chain.isSuppressiblePeds == true);
        }

        const deepestChainDepth = this.state.results != null ? this.state.results.deepestChainDepth : 0;
        const { user, submittedDateTime, startedDateTime, completedDateTime, completionTime } = this.state.matchRun;

        if (this.state.running && this.state.matchRun != null) {
            return (
                <ContainerWrapper className='container'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                        <div>Waiting for match run to complete...</div>
                        {this.state.scenario ? <div>Scenario: <Label style={{ fontSize: '100%' }}>{this.state.scenario.group.name} {this.state.scenario.title}</Label></div> : null}
                    </div>
                    {this.renderProgress(this.state.matchRun)}
                </ContainerWrapper>
            );
        }

        const isLoopRun = this.state.matchRun.matchRunType == MatchRunType.Loops;

        return (
            <>
                <ContainerWrapper className='container' style={{ width: '1400px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Match Run Results</div>
                        <div className={this.state.scenario ? this.state.scenario.group.cssClass : null}>
                            {this.state.scenario ? <>Scenario: <Label style={{ fontSize: '100%' }}>{this.state.scenario.group.name} {this.state.scenario.title}</Label></> : ''}
                        </div>
                    </div>

                    <Well className='row' bsSize='sm'>
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>Match Run</strong><br />{this.state.matchRun.matchRunTypeDescription}</div>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>User</strong><br />{user != '' ? user : 'SYSTEM'}</div>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>Submitted</strong><br />{submittedDateTime}</div>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>Started</strong><br />{startedDateTime}</div>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>Completed</strong><br />{completedDateTime != '' ? completedDateTime : '[Pending]'}</div>
                            <div style={{ marginRight: 20, textAlign: 'center' }}><strong>Completion Time</strong><br />{completionTime != '' ? completionTime : '[Pending]'}</div>
                            <div style={{ textAlign: 'center' }}>
                                <OverlayTrigger trigger='click' placement='left' rootClose overlay={this.getConfigOverlay()}><a style={{ cursor: 'default' }}>Match Run<br />Configuration</a></OverlayTrigger>
                            </div>
                        </div>
                    </Well>

                    {this.state.chainDisplay.filter(x => x.chain.path.length > 0).length > 0 ?
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '47%' }}>
                                    <StringDepth
                                        swaps={this.state.swaps}
                                        deepestChainDepth={deepestChainDepth}
                                        isLoopRun={isLoopRun}
                                    />
                                </div>

                                <div style={{ width: '47%', display: 'flec', justifyContent: 'flex-end' }}>
                                    <RunStatistics
                                        results={this.state.results}
                                        isLoopRun={isLoopRun}
                                    />
                                </div>
                            </div>

                            <br />

                            {this.state.matchRun.matchRunType == MatchRunType.Chains ?
                                <>
                                    <div className='row'>
                                        <div className='col-xs-12' style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <ChainStarterList
                                                swaps={this.state.swaps}
                                                deepestChainDepth={deepestChainDepth}
                                                donors={this.state.donors}
                                            />
                                        </div>
                                    </div>

                                    <br />
                                </>
                                :
                                <>
                                    {__ENVIRONMENT__ == 'dev' && (
                                        <div className='row'>
                                            <div className='col-xs-12' style={{ paddingLeft: 0, paddingRight: 0 }}>
                                                <ChainStarterListLoops
                                                    swaps={this.state.swaps}
                                                    deepestChainDepth={deepestChainDepth}
                                                    donors={this.state.donors}
                                                    selectedChainStarters={this.state.selectedChainStarters}
                                                    onSelectedChainStartersChanged={this.handleSelectedChainStartersChanged}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </>
                            }

                            <div className='row'>
                                <div className='col-xs-12' style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <Chains
                                        list={chainList}
                                        settings={this.state.settings}
                                        sortBy={this.state.sortBy}
                                        suppressPeds={this.state.suppressPeds}
                                        suppressEpletMM={this.state.suppressEpletMM}
                                        suppressAge={this.state.suppressAge}
                                        suppressBloodType={this.state.suppressBloodType}
                                        hideSuppressButtons={this.state.hideSuppressButtons}
                                        onSuppressPeds={this.handleSuppressPeds}
                                        onSuppressEpletMM={this.handleSuppressEpletMM}
                                        onSuppressBloodType={this.handleSuppressBloodType}
                                        onSuppressAge={this.handleSuppressAge}
                                        onSortChanged={this.handleChainSortChanged}
                                        onExpand={this.handleExpandChange}
                                        onExpandAll={this.handleExpandAll}
                                        onSelect={this.handleSelectChange}
                                        onDeleteSelected={this.handleDeleteSelected}
                                        onRestoreDeleted={this.handleRestoreDeleted}
                                    />
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <Alert className='row text-center' bsStyle='warning'>
                                No matches found
                            </Alert>
                        </>
                    }

                    <br />

                    {expandedPositions.length > 0 && (
                        <div className='row'>
                            <div className='col-xs-12' style={{ paddingLeft: 0, paddingRight: 0 }}>
                                <Positions
                                    list={expandedPositions}
                                    settings={this.state.settings}
                                    swapFailures={this.state.showSwapFailureColorCoding == 1 ? this.state.swapFailures : []}
                                    matchRunType={this.state.matchRun.matchRunType}
                                    oneWays={this.state.oneWays}
                                    epletMmRiskList={this.state.epletMmRiskList}
                                    donorsPerMonthByAbo={this.state.donorsPerMonthByAbo}
                                    showLoading={this.props.showLoading}
                                    hideLoading={this.props.hideLoading}
                                    onRequestExm={this.handleRequestExm}
                                    onBatchRequestExm={this.handleRequestExmBatch}
                                    onMakeMatchOffer={this.handleMakeMatchOffer}
                                    onHide={this.handleHide}
                                    onGetAcceptsData={this.props.getAcceptsData}
                                />
                            </div>
                        </div>
                    )}
                    <RefreshWarning show={this.state.showWarning} onClose={this.handleCloseWarning} />
                </ContainerWrapper>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        centerList: appState.centers.list
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getMatchRun: (id) => {
            return dispatch(MatchingActionCreators.getMatchRun(id));
        },
        getResults: (id) => {
            return dispatch(MatchingActionCreators.getResultsNew(id));
        },
        getScenarios: () => {
            return dispatch(MatchingActionCreators.getScenariosNew());
        },
        requestExm: (matchRunId, key, donorId, recipientId) => {
            return dispatch(MatchingActionCreators.requestExm(matchRunId, key, donorId, recipientId));
        },
        requestExmBatch: (matchRunId, list) => {
            return dispatch(MatchingActionCreators.requestExmBatch(matchRunId, list));
        },
        makeMatchOffer: (donorList, recipientList, isChain) => {
            return dispatch(MatchingActionCreators.makeMatchOffer(donorList, recipientList, isChain));
        },
        getAcceptsData: (id, centerId) => {
            return dispatch(DonorActionCreators.getProfileAcceptsData(id, centerId, true));
        },
        getDonorsPerMonthByAbo: () => {
            return dispatch(TargetActionCreators.getDonorsPerMonthByAbo());
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Results)